import angular from 'angular';

export class ResponsiveService {
    constructor($timeout, $window) {
        'ngInject';
        this.mobileCutoff = 700;
        this.$timeout = $timeout;
        this.$window = $window;
        this.data = {};
        this._startWatching();
        this._setMobileStatus();
    }

    _startWatching() {
        angular.element(this.$window).on('resize', this._updateView.bind(this));
    }

    _updateView() {
        // Use $timeout instead of explicit $rootScope.$apply()
        // See https://stackoverflow.com/a/18996042/1437395
        const callback = this._setMobileStatus.bind(this);
        this.$timeout(callback);
    }

    _setMobileStatus() {
        this.data.isMobile = this.$window.innerWidth <= this.mobileCutoff;
    }
}
